/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import { externalCheckoutUrl } from '@/helpers/routeHelpers'
import Config from 'theme/config'
const whiteList = ['thankyou']

export async function init ({ route, store }) {
  if (process.client) {
    const cartId = store.state.cart.cartId
    const token = store.state.user.token
    // sync cart
    // close panels if open
    store.commit('ui/setTopActiveComponent', {})
    store.commit('ui/setRightActiveComponent', {})
    store.commit('ui/setLeftActiveComponent', {})
    store.commit('ui/setBottomActiveComponent', {})
    store.commit('ui/setSubMenuActiveComponent', {})
    store.commit('ui/showSearch', false)
    store.commit('category/setCurrent', {})
    store.commit('category/fillOutBreadcrumb')
    store.commit('listing/setQuickViewForInstantSearch', false)

    // prevent closing if router refresh
    if (!store.state.ui.routerRefresh) {
      store.commit('quickBuy/setToggle', false)
    }

    if (store.state.ui.storeViewCode) {
      if (!whiteList.includes(route.name)) {
        if (cartId) {
          !store.state.cart.busySync && store.dispatch('cart/syncServerCart', {})
        } else {
          store.dispatch('cart/empty', null)
        }
      }
      if (Config.Theme.externalCheckout && ['checkout'].includes(route.name)) {
        global.location.href = externalCheckoutUrl(token, cartId, store.state.ui.storeViewCode)
      }
    }
  }
}
